import { useEffect, useState } from "react";
import { getGenericResearchQueryBackup } from "../services/ResearchQueriesService";

const useFetchGenericResearchQueryBackups = ({
  genericResearchQueryId,
  setIsLoading,
  page,
  pSize,
}: any) => {
  const [genericResearchQueryBackupData, setGenericResearchQueryBackupData] =
    useState<any>();
  useEffect(() => {
    if (genericResearchQueryId && genericResearchQueryId > 0) {
      setIsLoading(true);
      const getGenericResearchQueryBackupData = async () => {
        try {
          const result = await getGenericResearchQueryBackup({
            genericResearchQueryId,
            page,
            pSize,
          });
          setGenericResearchQueryBackupData(result);
        } catch (err) {
          setGenericResearchQueryBackupData({});
        } finally {
          setIsLoading(false);
        }
      };
      getGenericResearchQueryBackupData();
    }
  }, [genericResearchQueryId, page, pSize]);

  return [genericResearchQueryBackupData];
};

export default useFetchGenericResearchQueryBackups;

